module.exports = vendor_042ac20b2594b35b8767;